export default {"src":"/_next/static/media/notarized_second_icon.268f8daf.svg","height":252,"width":294,"blurWidth":0,"blurHeight":0};